import imageToBase64 from 'image-to-base64/browser';
import VueGoodshareFacebook from 'vue-goodshare/src/providers/Facebook.vue';
import VueGoodshareLinkedin from 'vue-goodshare/src/providers/LinkedIn.vue';
import VueGoodshareTwitter from 'vue-goodshare/src/providers/Twitter.vue';
import firebase from 'firebase/app';
import { deleteFileByUrl } from '@/utils/upload-image';
import ConfirmDlg from '@/components/popup/confirm-dialog/ConfirmDlg.vue';
import SharePhotoDlg from "@/views/staff/gallery/SharePhotoDlg/SharePhotoDlg.vue";
import Loader from "@/components/loader/Loader.vue";

export default {
  name: 'GalleryEventPicturesView',
  components: {
    VueGoodshareFacebook,
    VueGoodshareLinkedin,
    VueGoodshareTwitter,
    SharePhotoDlg,
    ConfirmDlg,
    Loader
  },
  data() {
    return {
      photoSrc: '',
      sharing: {
        title: '',
        description: '',
        quote: 'u',
        hashtags: '',
      },
      addMediaDialog: false,
      currentPhoto: '',
      loading: {
        page: true,
        delete: false,
      },
      selectedPhotos: [],
    };
  },

  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility
    },
    currentEvent() {
      return this.$store.state.calenderModule.currentCalenderEvent;
    }
  },

  async created() {
    await this.$store.dispatch("getCalenderEvent", this.$route.params.id).then(() => {
      this.loading.page = false;
    });

    this.sharing.title = this.$i18n.messages[this.$i18n.locale]['Gallery.CheckOutOurLatestPhoto']
  },

  beforeDestroy() {
    this.$store.state.calenderModule.currentCalenderEvent = null;
  },

  methods: {
    onPhotoSelect(isSelected, photo) {
      if (isSelected) {
        this.selectedPhotos.push(photo)
      }
      else {
        this.selectedPhotos = this.selectedPhotos.filter(x => x.photoUrl != photo.photoUrl)
      }
    },

    async downloadPhoto(url) {
      try {
        const ImageUrl = url;
        const ImageBase64 = await imageToBase64(ImageUrl);
        const a = document.createElement('a');
        a.href = 'data:image/png;base64,' + ImageBase64;
        a.download = 'Photo.png';
        a.click();
      } catch (error) {
        console.error(error);
      }
    },

    async deletePhoto() {

      if (this.selectedPhotos.length <= 0) return

      this.$refs.confirmationModal
        .open(null,
          this.selectedPhotos.length > 1 ? this.$i18n.messages[this.$i18n.locale]['Gallery.AreYouSureYouWantToDeleteThesePicturesMessage'] :
            this.$i18n.messages[this.$i18n.locale]['Gallery.AreYouSureYouWantToDeleteThisPictureMessage'], false)
        .then(async (response) => {
          if (response && response.agree) {
            await this.deletePhotos(this.selectedPhotos)
          }
        });
    },

    async deletePhotos(photos) {
      this.loading.delete = true;

      for(const photo of photos) {
        await firebase
          .firestore()
          .collection('calender')
          .doc(this.$route.params.id)
          .update({
            galleryPhotos: firebase.firestore.FieldValue.arrayRemove(photo)
          })
          .then(async () => {
            await deleteFileByUrl(photo.photoUrl)
              .then(async () => {
                return true;
              })
          })
          .catch(() => {
            this.$toast.open({
              message: this.$i18n.messages[this.$i18n.locale]['Gallery.PhotoCannotBeDeletedMessage'],
              type: 'error',
            });
          });
      }

      this.loading.delete = false;
      this.addMediaDialog = false;

      await this.$store.dispatch("getCalenderEvent", this.$route.params.id);

      this.$toast.open({
        message: photos.length > 1? this.$i18n.messages[this.$i18n.locale]['Gallery.PhotosSuccessfullyDeleted'] : this.$i18n.messages[this.$i18n.locale]['Gallery.PhotoSuccessfullyDeleted'],
        type: 'success',
      });

      setTimeout(() => {
        if(!this.currentEvent.galleryPhotos?.length) {
          this.$router.push("/gallery/event-pictures");
        }
      }, 500)
    },

    openDialog(event, photo) {
      if (event.target.className.includes('selection-controls')) return

      this.photoSrc = photo.photoUrl;
      this.currentPhoto = photo;
      this.addMediaDialog = true;
    },

    sharePhotoByEmail(photo) {
      this.$refs.sharePhotoDlg.open(photo);
    }
  },
};
